import React from 'react'

const Manual_forma_envio_radio_operacion = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configurar forma de envío de radio de operación
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo establecer un radio de entrega en tu tienda Clau.io, limitando las zonas de envío según distancia.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configurar_forma_de_envio_de_radio_de_operacion__Hx5NAKJeToirJabNdUZJGg?as=scrollable"
          className="scribe-iframe-general-108"
          width="100%"
          height="7800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_forma_envio_radio_operacion
